"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var timer_1 = __importDefault(require("./tools/timer"));
var resources_1 = __importDefault(require("./resources"));
var types_1 = require("./data/types");
var rand_1 = require("./tools/rand");
var mathjs_1 = require("mathjs");
var config_1 = __importDefault(require("../config"));
var Farm = /** @class */ (function () {
    function Farm(_a) {
        var _b = (_a === void 0 ? {
            delay: config_1.default.initialFarmDelay
        } : _a).delay, delay = _b === void 0 ? config_1.default.initialFarmDelay : _b;
        this.delay = delay;
        this.timer = new timer_1.default({
            delay: delay,
            autoStart: false
        });
        this.counter = 0;
    }
    Farm.hydrate = function (obj) {
        var farm = Object.assign(new Farm(), obj);
        farm.timer = timer_1.default.hydrate(obj.timer);
        return farm;
    };
    Farm.prototype.start = function (_a) {
        var _this = this;
        var player = _a.player, callback = _a.callback;
        var delay = this.delay * mathjs_1.pow(mathjs_1.log(this.counter + 2), 5);
        if (player.dex() > 0) {
            delay /= player.dex() * player.level;
        }
        if (player.vit() > 0) {
            delay /= player.vit() * player.level;
        }
        delay = delay < 1 ? this.delay : delay;
        var cb = function () {
            _this.timer.pause();
            // calculate amount of all resources first
            var amount = player.level;
            // todo fine tune this
            amount = amount * (player.atk() + player.matk());
            var resources = new resources_1.default();
            var resTypes = [
                types_1.ResourceTypes.Wood,
                types_1.ResourceTypes.Metal,
                types_1.ResourceTypes.Cloth,
                types_1.ResourceTypes.Diamond
            ];
            // now distribute
            while (amount > 0) {
                var resType = rand_1.getRandomArrayItem({
                    array: resTypes
                });
                resources[resType] = resources[resType] ? resources[resType]++ : 1;
                amount--;
            }
            _this.counter++;
            // todo calculate dmg based on defense and dmg dealt
            var dmg = (rand_1.getRandomInt(5, 15) * _this.counter) - (player.def() + player.mdef());
            if (dmg < 0) {
                dmg = 0;
            }
            callback({
                result: new resources_1.default({
                    resources: resources
                }),
                // todo calculate exp based on farm level
                exp: 4 * _this.counter,
                dmg: dmg,
                // todo calculate stamina used
                usedStamina: _this.counter
            });
        };
        this.timer = new timer_1.default({
            delay: delay,
            callback: cb
        });
    };
    return Farm;
}());
exports.default = Farm;
